import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import React from 'react';
import { useUser } from '../../../../hooks/use_user';
import { MuxPlayer, standardPlayerOptionsNoFullscreen } from '../../../muxPlayer/muxPlayer';
import {
  LayerInfo,
  LAYER_TYPES,
  MapLayerState,
  OVERLAY_LAYER,
  POINTS_OF_INTEREST_LAYER,
  WEATHER_LAYER,
} from '../../map_types';
import { FooterCard } from './footer_card';
import styles from './layers_detail_card.less';
import { LayerCard } from './layer_card';

interface LayersDetailCardProps {
  isLayerLocked?: (layer: LayerInfo) => boolean;
  mapLayerState: MapLayerState;
  onLayersDetailsSelect: (layer: LayerInfo) => void;
  onLockedLayerClick: () => void;
  onModalChange: (value: boolean) => void;
  onSelectedLayerInfoChange: (layer: LayerInfo | null) => void;
  selectedLayerInfo: LayerInfo;
}

const isLayerChecked = (l: LayerInfo, layerState: MapLayerState) => {
  switch (l.layerType) {
    case LAYER_TYPES.OVERLAY:
      return layerState[LAYER_TYPES.OVERLAY].includes(l.value as OVERLAY_LAYER);
    case LAYER_TYPES.WEATHER:
      return layerState[LAYER_TYPES.WEATHER].includes(l.value as WEATHER_LAYER);
    case LAYER_TYPES.POINTS_OF_INTEREST:
      return layerState[LAYER_TYPES.POINTS_OF_INTEREST].includes(
        l.value as POINTS_OF_INTEREST_LAYER
      );
    case LAYER_TYPES.CORE:
      return layerState[LAYER_TYPES.CORE] === l.value;
  }
};

export const LayersDetailCard = (props: LayersDetailCardProps) => {
  const {
    isLayerLocked,
    mapLayerState,
    onLayersDetailsSelect,
    onLockedLayerClick,
    onModalChange,
    onSelectedLayerInfoChange,
    selectedLayerInfo,
  } = props;

  const { isPro, user } = useUser();
  const noUser = !user;
  const isUserNotPremPro = !isPro;

  return (
    <div className={styles.layerDetailsSection}>
      <div className={styles.iconButtons}>
        <ArrowLeftOutlined
          onClick={(e) => {
            e.stopPropagation();
            onSelectedLayerInfoChange(null);
          }}
        />
        <CloseOutlined onClick={() => onModalChange(false)} />
      </div>
      <div className={styles.layerCardWrapper}>
        <LayerCard
          layer={selectedLayerInfo}
          checked={isLayerChecked(selectedLayerInfo, mapLayerState)}
          onSelect={() => {
            const layerIsFree = !isLayerLocked(selectedLayerInfo);
            const layerIsNotFree = isLayerLocked(selectedLayerInfo);
            if (user && isPro) {
              onLayersDetailsSelect(selectedLayerInfo);
              return;
            }
            if (layerIsFree) {
              onLayersDetailsSelect(selectedLayerInfo);
              return;
            }

            if (layerIsNotFree) {
              if (noUser || isUserNotPremPro) {
                onLockedLayerClick();
              }
            }
          }}
          showDetailsButton={false}
          useButton={selectedLayerInfo.layerType === LAYER_TYPES.CORE}
          isLocked={isLayerLocked(selectedLayerInfo)}
        />
      </div>
      {selectedLayerInfo?.muxPlaybackId && (
        <MuxPlayer
          thumbnail={selectedLayerInfo.thumbnail}
          playbackId={selectedLayerInfo.muxPlaybackId}
          playerOptions={standardPlayerOptionsNoFullscreen}
        />
      )}
      <span className={styles.description}>{selectedLayerInfo.description}</span>
      <FooterCard className={styles.footer} />
    </div>
  );
};
